import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-desc-click';

	$(base, context).each(function(){
		var component = $(this);
		var modal = $('#orderService').closest('.b-modal');

		component.on('click', function() {
			var text = $(this).data('structure');

			modal.on('ajaxAfterOpen', function() {
				modal.find('.i-desc-message').text(text);
			});
		});
	});
});